<template>
  <div v-if="label" class="inline-block custom-tag">
    <el-tag size="mini" :type="value">
      {{ label }}
    </el-tag>
  </div>
</template>

<script>
export default {
  props: {
    value: { type: String, default: '' },
    label: { type: String, default: '' },
  },
}
</script>

<style lang="scss" scoped>
.custom-tag {
  .el-tag {
    border: none;
  }
  .el-tag--A {
    color: #ffffff;
    background-color: #28a745;
  }
  .el-tag--P {
    color: #ffffff;
    background-color: #e7a23d;
  }
  .el-tag--R {
    color: #ffffff;
    background-color: #007bff;
  }
}
</style>
